import { render, staticRenderFns } from "./CommodityApply.vue?vue&type=template&id=cad9a334&scoped=true&"
import script from "./CommodityApply.vue?vue&type=script&lang=js&"
export * from "./CommodityApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad9a334",
  null
  
)

export default component.exports